import context from '@/context'
import { GridColumn as Column } from '@progress/kendo-react-grid/dist/npm/GridColumn'
import { BsrsGrid, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import React, { useState } from 'react'
import { TdActions } from '@/components/tdActions'
import { Button } from '@/components/button'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import getComponentKey from '@/utils/getComponentKey'
import { useLocalization } from '@/hooks/localization'
import LoadingIndicator from '@/components/LoadingIndicator'

const CbiAvailableBlacklists = ({ personId }) => {
  const { localize } = useLocalization()
  const [gridKey, setGridKey] = useState(getComponentKey())
  const [isLoading, setIsLoading] = useState(false)

  const availableCommandCell = ({ dataItem }) => {
    return <TdActions>
      <Button className={'btn btn-sm'} onClick={() => {
        getStore().dispatch(dialogActions.openDialog({
          dialogType: dialogTypes.confirm,
          title: 'Individuals.CreateBlacklistRecord',
          content: 'Individuals.CreateBlacklistRecordContent',
          onAction: () => {
            setIsLoading(true)
            return context.api.blacklistRecordService.addBlacklistFromCbi({
              cbiBlacklistRecordId: dataItem.id,
              individualId: personId
            }).then(() => setGridKey(getComponentKey()))
              .finally(() => setIsLoading(false))
          }
        }))
      }} icon={'save'} iconOnly />
      <Button className={'btn btn-sm'} onClick={() => {
        setIsLoading(true)
        return context.api.blacklistRecordService.ignoreCbiBlacklistRecord({
          cbiBlacklistRecordId: dataItem.id,
          individualId: personId
        }).then(() => setGridKey(getComponentKey()))
          .finally(() => setIsLoading(false))
      }} icon={'x'} iconOnly />
    </TdActions>
  }

  return !isLoading ? <BsrsGrid
    name='cbiBlacklists' inputType='grid' readonly
    lastReloadedAt={gridKey}
    dataSource={(request, opts) => context.api.individualService.getCbiBlacklistRecords(personId, request, opts)}>
    <Column field='codeId' title={localize('Individuals.CodeId')} />
    <Column field='nationalId' title={localize('Individuals.NationalId')} />
    <Column field='fullName' title={localize('Individuals.FullName')} />
    <Column field='motherName' title={localize('Individuals.MotherName')} />
    <Column field='validFrom' title={localize('Common.ValidFrom')} cell={DateCell} filterCell={DateFilterCell} filter='date' />
    <Column field='validTo' title={localize('Common.ValidTo')} cell={DateCell} filterCell={DateFilterCell} filter='date' />
    <Column cell={availableCommandCell} filterable={false} editable={false} />
  </BsrsGrid> : <LoadingIndicator />
}

export { CbiAvailableBlacklists }



// WEBPACK FOOTER //
// ./src/components/demographics/cbiAvailableBlacklists.js